/* src/app/landingpages/gcse-classes/gcse-classes.component.css */
.hero-section {
  text-align: center;
  padding: 3rem 1rem;
  font-family: Arial, sans-serif;
  margin-top: 10rem;
}
.hero-content h1 {
  font-size: 4rem;
  font-weight: 700;
}
.highlight-blue {
  color: #129fdb;
}
.highlight-black {
  color: #129fdb;
}
.subheading {
  margin-top: 0.5rem;
  font-size: 2rem;
  color: #333;
}
.subheading a {
  color: #129fdb;
  font-weight: 600;
  text-decoration: none;
}
.subheading .classes {
  margin-left: 50px;
  font-weight: 600;
}
.hero-image img {
  max-width: 80%;
  height: auto;
  border-radius: 0px;
  margin: 2rem auto;
  display: block;
}
.cta-buttons {
  margin: 1.5rem 0;
}
.btn1 {
  display: inline-block;
  padding: 1.1rem 4rem;
  border-radius: 60px;
  font-weight: 600;
  margin: 0.8rem;
  text-transform: none;
}
.btn-blue {
  background: #007ba7;
  color: #fff;
}
.btn-yellow {
  background: #f5af12;
  color: #000000;
}
.testimonial-heading {
  margin-top: 5rem;
  font-size: 4rem;
  font-weight: 500;
  color: #007BA7;
}
.testimonial-heading .underline {
  text-decoration: underline;
  text-decoration-thickness: 3px;
  text-underline-offset: 30px;
}
.youtube-videos {
  display: flex;
  justify-content: center;
  gap: 10rem;
  flex-wrap: wrap;
  margin: 6rem 0;
}
.youtube-videos iframe {
  width: 350px;
  height: 200px;
}
.success-strip {
  background: #ffb400;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  padding: 3rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10rem;
}
.success-strip p {
  font-weight: 600;
  font-size: 3rem;
  color: #111;
  margin: 0.9rem 0;
  margin-left: 10rem;
}
.success-strip .btn2 {
  margin: 0.5rem 0;
  margin-right: 12rem;
  border-radius: 60px;
  padding: 1.5rem 6rem;
  font-size: 1.8rem;
}
.strategy-section {
  width: 100%;
  max-width: 1300px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
  margin: 4rem auto;
  align-items: flex-start;
}
.strategy-left {
  min-width: 250px;
}
.strategy-left .heading {
  color: #007BA7;
  font-size: clamp(4rem, 5vw, 5rem);
  white-space: nowrap;
  margin-top: 6rem;
  margin-bottom: 1rem;
}
.strategy-left p {
  font-size: 3.5rem;
  font-weight: 600;
  white-space: nowrap;
}
.strategy-right {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.top-row {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  margin: 0 2rem 3rem 0;
}
.bottom-row {
  grid-column: 1 / -1;
  display: flex;
  gap: 3.3rem;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0;
}
.flip-card {
  background: transparent;
  width: 230px;
  height: 350px;
  perspective: 1000px;
  flex-shrink: 0;
}
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}
.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #ccc;
}
.flip-card-front {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: white;
}
.flip-card-front img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  object-fit: cover;
  display: block;
}
.card-title {
  background: #ffb400;
  text-align: center;
  padding: 1rem;
  font-weight: 600;
}
.flip-card-back {
  background: #ffb400;
  color: black;
  transform: rotateY(180deg);
  padding: 1rem;
  font-size: 0.9rem;
  text-align: center;
}
.flip-card-back ul {
  list-style: none;
  padding: 0;
  margin: 1rem 0 0 0;
  text-align: left;
}
.flip-card-back li {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  position: relative;
  padding-left: 1.2rem;
}
.flip-card-back li::before {
  content: "\2022";
  color: #111;
  font-size: 1.2rem;
  position: absolute;
  left: 0;
  top: 0.1rem;
}
.flip-card-back h3 {
  margin-bottom: 0.5rem;
  font-size: 1.6rem;
}
.subjects {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 6rem;
}
.subjects h1 {
  font-size: 40px;
  font-weight: 550;
  color: #005f7f;
  margin-bottom: 25px;
  text-align: center;
}
.subject-list {
  display: flex;
  align-items: center;
  list-style: disc;
  gap: 30px;
}
.u {
  gap: 65px;
}
.subject-list li {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  padding: 8px 0;
}
.course-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 50px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 5rem;
}
.course-card {
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 400px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
.card-header {
  padding: 25px 25px 20px;
  color: white;
  font-weight: bold;
}
.orange-gradient {
  background: #007BA7;
}
.card-name {
  font-size: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.title-icon {
  font-size: 18px;
}
.card-subtitle {
  font-size: 14px;
  font-weight: normal;
  line-height: 1.4;
}
.card-content {
  padding: 25px;
  background: white;
}
.info-section {
  margin-bottom: 20px;
}
.section-label {
  font-weight: bold;
  color: #333;
  font-size: 14px;
  margin-bottom: 5px;
}
.section-text {
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}
.feature-list {
  list-style: none;
  padding-left: 0;
}
.feature-list li {
  position: relative;
  padding-left: 15px;
  margin-bottom: 3px;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}
.feature-list li::before {
  content: "\2022";
  position: absolute;
  left: 0;
  color: #f39c12;
  font-weight: bold;
}
.demo-btn {
  width: 100%;
  background:
    linear-gradient(
      135deg,
      #3498db,
      #2980b9);
  color: white;
  border: none;
  padding: 15px 20px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}
.demo-btn:hover {
  background:
    linear-gradient(
      135deg,
      #2980b9,
      #21618c);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
}
.rar {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 6rem;
}
.rar h1 {
  font-size: 40px;
  font-weight: 550;
  color: #005f7f;
  margin-bottom: 10px;
  text-align: center;
}
.rar h3 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 25px;
  text-align: center;
}
.section-6 {
  margin-top: 50px;
  background-color: #ffffff;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.section-6 h1 {
  font-size: 40px;
  font-weight: 550;
  text-align: center;
}
.gallery-container {
  display: flex;
  width: 100%;
  padding: 20px;
}
.gal-left {
  width: 50%;
  padding: 30px;
}
.gal-left img {
  border-radius: 20px;
  width: 100%;
  height: 600px;
  object-fit: cover;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.large-image.zoom {
  transform: scale(1.1);
  opacity: 0.7;
}
.gal-right {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.gal-right h1 {
  font-size: 40px;
  font-weight: 500;
  margin-top: auto;
  margin-bottom: 50px;
  transition: opacity 0.3s ease-in-out;
}
.btn-div {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
}
.gal-btn {
  padding: 15px 30px;
  border: none;
  border-radius: 30px;
  background-color: #007ba7;
  margin-bottom: 150px;
  color: white;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  transition: background-color 0.3s ease-in-out;
}
.sd {
  background-color: #ffbf00;
}
.gal-btn:hover {
  background-color: #ED6823;
}
.sd:hover {
  background-color: #ffffff;
  color: #ED6823;
}
.gal-thumb {
  width: 100%;
  display: flex;
  gap: 20px;
  margin: 20px;
}
.gal-thumb img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 20px;
  margin-top: auto;
  transition: transform 0.3s ease-in-out, border 0.3s ease-in-out;
}
.gal-thumb img:hover,
.gal-thumb img.active {
  transform: scale(1.2);
  border: 3px solid orange;
}
@media (max-width: 1024px) {
  .hero-content h1 {
    font-size: 2.8rem;
    margin-top: 5rem;
  }
  .subheading {
    font-size: 1.4rem;
  }
  .youtube-videos {
    gap: 3rem;
  }
}
@media (max-width: 768px) {
  .hero-section {
    padding: 2rem 1rem;
    margin-top: 6rem;
  }
  .hero-content h1 {
    font-size: 2.2rem;
  }
  .subheading {
    font-size: 1.2rem;
    margin-top: 0.8rem;
  }
  .hero-image img {
    max-width: 100%;
  }
  .btn1,
  .btn2,
  .demo-btn,
  .gal-btn {
    padding: 0.9rem 2rem;
    font-size: 1rem;
    border-radius: 40px;
    width: auto;
    max-width: 80%;
  }
  .cta-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .testimonial-heading {
    font-size: 2rem;
    text-align: center;
  }
  .testimonial-heading .underline {
    text-decoration-thickness: 2px;
    text-underline-offset: 10px;
  }
  .success-strip {
    flex-direction: column;
    text-align: center;
    padding: 2rem 1rem;
    gap: 1.5rem;
  }
  .success-strip p {
    font-size: 1.5rem;
    margin: 0;
  }
  .success-strip .btn2 {
    margin: 0 auto;
    padding: 1rem 2.5rem;
    font-size: 1.2rem;
  }
  .strategy-section {
    grid-template-columns: 1fr;
    gap: 1rem;
    text-align: center;
  }
  .strategy-left .heading {
    font-size: 2rem;
    margin-top: 2rem;
  }
  .strategy-left p {
    font-size: 1.5rem;
  }
  .top-row,
  .bottom-row {
    justify-content: center;
    margin: 0 auto;
  }
  .flip-card {
    width: 150px;
    height: 230px;
  }
  .subject-list {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }
  .subject-list li {
    font-size: 16px;
  }
  .course-card {
    width: 100%;
    max-width: 350px;
  }
  .rar h1 {
    font-size: 2rem;
  }
  .rar h3 {
    font-size: 1rem;
    margin-bottom: 15px;
  }
  .rar img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
  }
  .gallery-container {
    flex-direction: column;
  }
  .gal-left,
  .gal-right {
    width: 100%;
    padding: 10px;
  }
  .gal-left img {
    height: auto;
    max-height: 350px;
  }
  .gal-right h1 {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  .gal-btn {
    font-size: 14px;
    padding: 10px 18px;
    margin-bottom: 40px;
  }
  .gal-thumb {
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .gal-thumb img {
    width: 70px;
    height: 70px;
  }
}
@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.8rem;
  }
  .subheading {
    font-size: 1rem;
  }
  .btn1,
  .btn2,
  .demo-btn {
    font-size: 0.9rem;
    padding: 0.8rem 1.8rem;
  }
  .testimonial-heading {
    font-size: 1.5rem;
  }
  .success-strip p {
    font-size: 1.2rem;
  }
  .course-card {
    max-width: 90%;
  }
  .gal-right h1 {
    font-size: 1.2rem;
  }
}
/*# sourceMappingURL=gcse-classes.component.css.map */
